import React from 'react';
import { styled } from '@mui/material';
import { Colors } from 'library';
import { RTitle } from './RTitle';

interface RPageHeaderProps {
    title: string;
    subtitle?: string;
    actions?: React.ReactNode;
}

export function RPageHeader({ title, subtitle, actions }: RPageHeaderProps) {
    return (
        <Header>
            <div>
                <RTitle size="h1">{title}</RTitle>
                {subtitle && <Subtitle>{subtitle}</Subtitle>}
            </div>
            {actions && <Actions>{actions}</Actions>}
        </Header>
    );
}

const Header = styled('div')({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: 24,
});

const Subtitle = styled('p')({
    fontSize: 15,
    color: Colors.mediumGrey,
    margin: '4px 0 0',
});

const Actions = styled('div')({
    display: 'flex',
    alignItems: 'center',
    gap: 12,
});
